import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { ProjectCommissionGetCollectionByProjectId, ProjectCommissionGetCollectionByProjectIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<ProjectCommissionGetCollectionByProjectIdResponse, ProjectCommissionGetCollectionByProjectIdResponse>) => {
    return response?.data?.projectCommissions;
}
const getError = (response?: SWRResponse<ProjectCommissionGetCollectionByProjectIdResponse, ProjectCommissionGetCollectionByProjectIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useProjectCommissionsByProjectId = (projectId: number, configuration?: SWRConfiguration<ProjectCommissionGetCollectionByProjectIdResponse, ProjectCommissionGetCollectionByProjectIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new ProjectCommissionGetCollectionByProjectId({
                projectId: projectId
            });
        };
    }, [projectId])

    return useGet(request, { getData, getError }, configuration);
}

export default useProjectCommissionsByProjectId;